import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useContactsCSVBuffer } from 'core/api/contacts';
import { CSVLink } from 'react-csv';
import Button from 'components/Button';
import Export from 'images/icons/Export.svg?react';

const ExportContact: FC = () => {
    const { t } = useTranslation();
    const csvData = useContactsCSVBuffer().data ?? [];

    return (
        <CSVLink data={csvData}>
            <Button variant="outlined">
                <Export />
                {t('contact.export-contacts')}
            </Button>
        </CSVLink>
    );
};

export default ExportContact;
